export default function About() {
  return (
    <section id="about" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              About Us
            </h2>
            <p className="text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              With over 15 years of experience in the cleaning industry, we've built our reputation on trust, reliability, and exceptional service. Our team of professional cleaners is dedicated to transforming your home into a spotless sanctuary.
            </p>
            <p className="text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              We understand that your home is your most valuable asset, which is why we treat every space with the utmost care and attention to detail. Our eco-friendly cleaning products ensure a safe environment for your family and pets while delivering outstanding results.
            </p>
            <p className="text-base text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              Whether you need a one-time deep clean or regular maintenance, we customize our services to meet your specific needs and schedule. Your satisfaction is our top priority, and we're not happy until you are.
            </p>
            <div className="grid grid-cols-3 gap-4 sm:gap-8">
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-bold text-teal-600 mb-1 sm:mb-2">15+</div>
                <div className="text-xs sm:text-sm text-gray-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-bold text-teal-600 mb-1 sm:mb-2">5000+</div>
                <div className="text-xs sm:text-sm text-gray-600">Happy Clients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-bold text-teal-600 mb-1 sm:mb-2">100%</div>
                <div className="text-xs sm:text-sm text-gray-600">Satisfaction</div>
              </div>
            </div>
          </div>
          <div className="relative mt-8 md:mt-0">
            <div className="w-full h-72 sm:h-96 md:h-[600px] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://storage.readdy-site.link/project_files/b6fad502-5571-409f-a788-fcef1702e1e5/da1bd545-ca09-4a87-8f3c-2685042e0055_WhatsApp-Image-2026-04-08-at-17.51.12-1.jpeg?v=85ffdc92a792f7e4622746e5ec8597b2" 
                alt="Our Professional Cleaning Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-teal-600 text-white p-5 sm:p-8 rounded-xl shadow-xl">
              <div className="text-2xl sm:text-3xl font-bold mb-1">Trusted</div>
              <div className="text-xs sm:text-sm">By Thousands</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
